var makeString = require('./helper/makeString');

module.exports = function capitalize(str, lowercaseRest) {
  str = makeString(str);
  var remainingChars = !lowercaseRest ? str.slice(1) : str.slice(1).toLowerCase();

  return str.charAt(0).toUpperCase() + remainingChars;
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/underscore.string/capitalize.js
 ** module id = 393
 ** module chunks = 0
 **/